module.exports = __webpack_public_path__ + "static/baslicasorunlar-39d0468c030bd10d2e8fc8e273539140.png";